import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 周年庆活跃玩法活动城堡主界面接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784195
export const getCastleActiveInfo = createAsyncThunk(
  'CastleActive/active_game_play_home_page',
  async (e, store: any) => {
    const resp = await http.post('/live/activity/active_game_play_home_page', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

// 周年庆活跃玩法活动升级或者保护城堡接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784721
// tab 1 升级 2 保护 3 领取宝石
// castle_id 城堡id
export enum OPERATECASTEL {
  升级 = 1,
  保护 = 2,
  领取宝石 = 3,
}
export const operateCastle = createAsyncThunk(
  'CastleActive/active_game_play_home_page',
  async (e: {tab: OPERATECASTEL; castle_id: number}, store: any) => {
    const resp = await http.post(
      '/live/activity/active_game_play_castle_operate',
      {
        ...store.getState().env.deviceinfo,
        ...e,
      }
    )
    return resp.data
  }
)

// tab 1 使用后台任务数据
// 周年庆活跃玩法活动修建城堡接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784234
// export const buildCastle = createAsyncThunk(
//   'CastleActive/active_game_play_build_castle',
//   async (e, store: any) => {
//     const resp = await http.post(
//       '/live/activity/active_game_play_build_castle',
//       {
//         ...store.getState().env.deviceinfo,
//       }
//     )
//     return resp.data
//   }

// tab 2 宝石偷取列表
// 周年庆活跃玩法活动城堡财富页面信息接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784409
export const castleWealth = createAsyncThunk(
  'CastleActive/active_game_play_castle_wealth',
  async (e: {offset: number}, store: any) => {
    const resp = await http.post(
      '/live/activity/active_game_play_castle_wealth',
      {
        ...store.getState().env.deviceinfo,
        ...e,
        limit: 20,
      }
    )
    return resp.data
  }
)

// 周年庆活跃玩法活动宝石商城购买接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784579
export const buyWealth = createAsyncThunk(
  'CastleActive/active_game_play_buy',
  async (e: {id: number}, store: any) => {
    const resp = await http.post('/live/activity/active_game_play_buy', {
      ...store.getState().env.deviceinfo,
      ...e,
    })
    return resp.data
  }
)

// 周年庆活跃玩法活动偷取好友财富接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784631
export const stealWealth = createAsyncThunk(
  'CastleActive/active_game_play_steal_wealth',
  async (e: {mid: number}, store: any) => {
    const resp = await http.post(
      '/live/activity/active_game_play_steal_wealth',
      {
        ...store.getState().env.deviceinfo,
        ...e,
      }
    )
    return resp.data
  }
)
// tab 3
// 周年庆活跃玩法活动宝石来源历史记录接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784676
export const recordWealth = createAsyncThunk(
  'CastleActive/active_game_play_steal_wealth',
  async (e, store: any) => {
    const resp = await http.post('/live/activity/active_game_play_gem_source', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

// 周年庆活跃玩法活动城堡主界面接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122785899
export const checkIn = createAsyncThunk(
  'CastleActive/active_game_play_check_in',
  async (e: {tab: number; day_th: number}, store: any) => {
    const resp = await http.post('/live/activity/active_game_play_check_in', {
      ...store.getState().env.deviceinfo,
      ...e,
    })
    return resp.data
  }
)

interface CastleInfo {
  castle_id: number
  current_level: number // 城堡等级
  is_locked: boolean // 是否解锁
  under_protect: boolean // 是否正在被保护
  upgrade_need: number // 升级所需
  current_gems: number // 目前拥有的可领取宝石数
}

export enum SIGNSTATUS {
  未签到 = 0,
  已签到 = 1,
  待解锁 = 2,
}
interface CheckInInfo {
  day_th: number
  status: SIGNSTATUS
  current_date: string
  is_today: boolean
}
interface FriendInfo {
  can_steal: boolean
  gem_num: number
  id: number
  name: string
  zy_id: string
  avatar: string
  gender: number
}

const initialState: {
  home_page: {
    is_first: boolean // 是否第一次
    list: CastleInfo[] // 城堡信息
    my_wealth: number // 当前宝石数量
    current_strength: number // 体力值
    protect_card: number // 保护卡
    re_check_in_card: number // 补签卡
    check_in_list: CheckInInfo[] // 签到list
    generate_gems: any // 不同等级城堡产生宝石数
  }
  castle_wealth: {
    msg: string
    my_wealth: number
    list: FriendInfo[]
    offset: number
    more: boolean
  }
} = {
  home_page: {
    is_first: false,
    list: [],
    my_wealth: 0,
    current_strength: 0,
    protect_card: 0,
    re_check_in_card: 0,
    check_in_list: [],
    generate_gems: {},
  },
  castle_wealth: {
    msg: '',
    my_wealth: 0,
    list: [],
    offset: 0,
    more: false,
  },
}

export const CastleActiveSlice = createSlice({
  name: 'CastleActive',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCastleActiveInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.home_page, data)
    })
    builder.addCase(castleWealth.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.home_page, data)
    })
  },
})
export default CastleActiveSlice.reducer
